@if (
  {
    loading: searchService.search_loading,
    isLoading: (searchParams.isLoading | async),
    results: (filteredResults$ | async) || []
  };
  as data
) {
  <app-taxi-loading-screen [animated]="false"></app-taxi-loading-screen>
  <div>
    <h2 class="visuallyhidden" i18n="@@taxis_searchCriteria">Search Criteria</h2>
    <a
      href="javascript:void(0)"
      (click)="skipToResultContent()"
      (keydown.enter)="skipToResultContent()"
      (keydown.space)="skipToResultContent()"
      role="link"
      class="sr-only sr-only-focusable"
      >Skip to Result Content</a
    >
    <app-invoked-user></app-invoked-user>
  </div>
  <app-validate-errors></app-validate-errors>
  <div class="taxi_research_form-container">
    <div class="taxi_research_form background-container-background">
      <app-search-toggle [serviceType]="taxiServiceType">
        <app-taxi-search [resultsMode]="true"></app-taxi-search>
      </app-search-toggle>
    </div>
    <app-risk-alerts [countryCode]="searchParams.toAddress?.Country"></app-risk-alerts>
  </div>
  <!-- <div class="flex-row-container flex-row-container--right flex-row-container--tb-margin">
    <app-sorting-toggle id='taxi'
      (sortingSelected)="onSortingSelected($event)"
    [sortingTypes]="sortingTypes"></app-sorting-toggle>
  </div> -->
  @if (!mapView) {
    <div class="taxi-results-container primary-text-colour">
      @if (!data.results.length && !data.isLoading) {
        <app-no-results></app-no-results>
      }
      @for (item of data.results; track item; let i = $index) {
        <div class="taxi-item">
          <div class="taxi-image">
            <!-- dont show images ontop of each other -->
            <div class="taxi-image_inner_1">
              <img
                src="https://images.sabscorp.com/images/TourOp/png/{{ item.supplierName }}.png"
                alt=""
              />
            </div>
            @if (item.additional?.providersPricing?.multiMedias?.multiMedia[1]?.mediaURL; as icon) {
              <div class="taxi-image_inner_2">
                <img [src]="icon" alt="Groundspan" />
              </div>
            } @else {
              <img [src]="cabIconUrl" alt="" />
            }
          </div>
          <div class="taxi-description">
            <div class="flex-row-container gap-2">
              <h2>{{ item.supplierName }}</h2>
              <app-preferred-icons
                [tmcPreferred]="item.tmcPreferred"
                [tmcPreferredLogoUrl]="item.tmcPreferredLogoUrl"
                [tmcPreferredMessage]="item.tmcPreferredMessage"
                [clientPreferred]="item.officePreferred || item.companyPreferred"
                [companyPreferredMessage]="item.companyPreferredMessage"
                [officePreferredMessage]="item.officePreferredMessage"
              >
              </app-preferred-icons>
            </div>
            <dl>
              @if (item?.vehicleType; as vehicleType) {
                <div class="inline-dl">
                  <dt class="light-fat" i18n="@@taxisVehicleType">Vehicle Type:</dt>
                  <dd>{{ vehicleType | translate }}</dd>
                </div>
              }
              @if (item?.fromLocation; as fromLocation) {
                <div class="inline-dl">
                  <dt class="light-fat" i18n="@@taxisFrom">From:</dt>
                  <dd>
                    <app-taxi-location [location]="fromLocation"></app-taxi-location>
                  </dd>
                </div>
              }
              @if (item?.toLocation; as toLocation) {
                <div class="inline-dl">
                  <dt class="light-fat" i18n="@@taxisTo">To:</dt>
                  <dd>
                    <app-taxi-location [location]="toLocation"></app-taxi-location>
                  </dd>
                </div>
              }
              <div class="inline-dl">
                <dt class="light-fat" i18n="@@taxiVia">Via:&nbsp;</dt>
                <dd class="via-locations">
                  @for (via of vias; track via) {
                    @if (via) {
                      <app-taxi-location [location]="via"></app-taxi-location>
                    }
                  }
                </dd>
              </div>
              @if (item?.departs; as departs) {
                <div class="time-dl">
                  <dt class="light-fat" i18n="@@taxisDate">Date:</dt>
                  <dd>{{ departs | sabsDate: 1 }}</dd>
                  <dt class="light-fat" i18n="@@taxisTime">Time:</dt>
                  <dd>{{ departs | sabsTimePipe: 'json_time' }}</dd>
                </div>
              }
            </dl>
            <section (mouseleave)="tt.close()" class="container">
              <button
                i18n-ngbTooltip
                ngbTooltip="Go to map view"
                (click)="goToMapView(item)"
                aria-label="Go to map view"
                triggers="manual"
                #tt="ngbTooltip"
                (mouseenter)="tt.open()"
                class="light-btn light-btn-ico light-btn-primary"
              >
                <i class="ico-map" aria-hidden="true"></i>
              </button>
            </section>
          </div>
          <div class="taxi-actions">
            <div class="taxi-details">
              <dl>
                @if (item?.tripDistanceMetres; as tripDistanceMetres) {
                  <div class="taxi-detail">
                    <dt i18n="@@taxisDistance" class="light-fat">Distance:</dt>
                    <dd>{{ tripDistanceMetres | sabsDistance: 'metres_to_miles' }}</dd>
                  </div>
                }
                @if (item?.tripDurationSeconds; as tripDurationSeconds) {
                  <div class="taxi-detail">
                    <dt i18n="@@taxisEstTime" class="light-fat">Est. Time:</dt>
                    <dd>{{ tripDurationSeconds | sabsSecondsPipe: 'hm' }}</dd>
                  </div>
                }
                <div class="taxi-detail">
                  <dt i18n="@@taxisPassengers" class="light-fat">Passengers:</dt>
                  <dd>{{ searchParams.adults + searchParams.children }}</dd>
                </div>
                <div class="taxi-detail">
                  <dt class="light-fat">CO2:</dt>
                  <dd>{{ item.estimatedCO2 }}kg</dd>
                </div>
              </dl>
            </div>
            <div class="taxi-btn-container">
              <button
                (click)="addToCart(item)"
                [disabled]="item.unavailable && !canOverride"
                class="light-btn light-btn-fancy"
                id="taxi-add-to-basket-{{ i }}"
                attr.aria-label="{{ item.price | currency: item.currency }} add to cart {{
                  item.supplier
                }}"
              >
                <span class="price-wrapper">
                  {{ item.price | currency: item.currency }}
                </span>
                <span i18n="@@taxiExecVat">(Excl VAT)</span>
                @if (!displayItinerary) {
                  <span i18n="@@taxisAddToCart">Add to basket</span>
                }
                @if (displayItinerary) {
                  <span i18n="@@taxisAddToItinerary">Add to itinerary</span>
                }
                <span class="visuallyhidden">{{ item.supplierName }}</span>
              </button>
              <app-warning-tags [iconId]="i" [ticket]="item"></app-warning-tags>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (mapView) {
    <app-map-view
      [title]="selectedItem.supplierName"
      bgColor="#33766f"
      [icon]="cabIconUrl"
      [center]="geolocation"
      [pins]="pins"
      [displayRoute]="true"
      (closeMapView)="onCloseMapView()"
    ></app-map-view>
  }
}
